import type { MouseEvent } from 'react'
import type { UsePlayer } from '~/widgets/Player/hooks/usePlayer'
import type { RecommendationItem } from '../index.h'

import { PlayerRecommendationsLayout } from "/app/libraries/arcana/src/blocks/PlayerRecommendationsLayout/index.ts"

import { useUnit } from 'effector-react'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { navigate } from '~/core/router'
import { markOpenedFromRecommendation } from '~/features/analytix'
import {
  $recommendationItems,
  closeRecommendations,
  resetRecommendations,
} from '../model'
import { RecommendationCard } from './RecommendationCard'

type RecommendationsOverlayProps = {
  player: UsePlayer
}

export function RecommendationsOverlay({
  player,
}: RecommendationsOverlayProps) {
  const { t } = useTranslation()
  const items = useUnit($recommendationItems)
  const resetRecommendationsEvent = useUnit(resetRecommendations)
  const isVisible = items.length > 0

  const handleClose = useCallback(() => {
    navigate.backOrHome()
  }, [])

  useEffect(() => {
    return () => resetRecommendationsEvent()
  }, [resetRecommendationsEvent])

  useEffect(() => {
    if (!isVisible) return

    player.instance?.pause?.()
  }, [isVisible, player])

  if (!items.length) return null

  const handleCardClick = (item: RecommendationItem) => (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    markOpenedFromRecommendation()
    closeRecommendations()
    navigate(item.detailPath)
  }

  return (
    <PlayerRecommendationsLayout
      title={t('choose_next_title')}
      itemCount={items.length}
      onClose={handleClose}
    >
      {items.map((item) => (
        <RecommendationCard
          key={`${item.contentType}-${item.id}`}
          item={item}
          onClick={handleCardClick(item)}
        />
      ))}
    </PlayerRecommendationsLayout>
  )
}
